import { type SsoConnection } from '@column/api';

import { type StatusBadgeTone } from '~/components/Table';

export const SSO_MANAGEMENT_ROLES = ['owner', 'admin'];
export const FEATURE_NOT_ENABLED = 'feature_not_enabled';
export const SSO_REDIRECT_URI = 'https://dashboard.column.com/sso/callback';
export const SSO_SCOPES = ['openid', 'email', 'profile'];

export const CONNECTION_ICON_BUTTON_CLASS_NAME =
  'text-gray-400 shadow-none hover:shadow-none dark:text-gray-500 dark:shadow-none';

export const SSO_MODES: { value: SsoConnection['mode']; label: string; description: string; tone: StatusBadgeTone }[] =
  [
    { value: 'off', label: 'Off', description: 'This connection cannot be used.', tone: 'default' },
    {
      value: 'optional',
      label: 'Optional',
      description: 'Users can sign in with this connection or their Column credentials.',
      tone: 'info',
    },
    {
      value: 'required',
      label: 'Required',
      description: 'Users on verified domains must sign in with this connection.',
      tone: 'success',
    },
  ];
